/* eslint-disable react/require-default-props */
import React from 'react';
import classNames from 'classnames';
import { CopyButton } from '../CopyButton';
import './CardSectionStyles.scss';
const baseClass = 'qmb-ui-card-section';
/**
 * CardSection Component
 * Renders a single label + content row with an optional copy button.
 * @version 1.0.0
 * @since 2026-02-18
 */
export function CardSection({ label, variant, children, copyText, isLast = false, className }) {
    return (React.createElement("div", { className: classNames(baseClass, { [`${baseClass}--last`]: isLast }, className) },
        React.createElement("div", { className: `${baseClass}__content` },
            label && (React.createElement("dt", { className: `${baseClass}__label` },
                variant === 'error' ? React.createElement("i", { className: "fa-light fa-circle-xmark" }) : null,
                " ",
                label)),
            React.createElement("dd", { className: `${baseClass}__value` }, children)),
        copyText && React.createElement(CopyButton, { text: copyText, className: `${baseClass}__copy` })));
}
